const getShippingMethodInitialTouched = (settings) => {
    const ret = {};
    const {  productSettings: { shipping_methods = [] }, } = settings;
    const autoSelectOnlyShippingMethod = shipping_methods.length === 1;
    const Shipping_Method = autoSelectOnlyShippingMethod ? shipping_methods[0].id : "";
    if (Shipping_Method) {
        ret.Shipping_Method = true;
    }

    return ret;
};

export const getInitialTouched = (settings, savedRegistrationValues = {}) => {
    const touched = {
        ...getShippingMethodInitialTouched(settings)
    };
    if (Object.keys(savedRegistrationValues).length > 0) {
        const savedTouched = Object.keys(savedRegistrationValues).reduce(
            (_touched, key) => {
                return {
                    ..._touched,
                    [key]: true,
                };
            },
            {},
        );
        return {
            ...touched,
            ...savedTouched,
        };
    }
    return touched;
};
